import { Injectable, inject } from '@angular/core'
import { ToastController, ToastOptions } from '@ionic/angular/standalone'

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	private toastControler = inject(ToastController)

	cssStyleSheetReplace = `
		.toast-wrapper {
			background-color: #ffffff !important;
			z-index: 999999 !important;
			font-weight: bold;
			font-size: 15px;
			color: #7f7f7f;
			box-shadow: 0px 1px 4px #00000029 !important;
			padding: 0;
			margin-right: 1em !important;
			margin-left: auto !important;
			.toast-content {
				padding: 0 !important;
			}
			.toast-button-group{
				display: flex;
				gap: 8px;
				flex-flow: row nowrap;
			}
			.toast-button{
				&.light {
					color: #00a3ff !important;
					background-color: #ffffff !important;
					&:hover {
						background-color: #f5f5f5 !important;
					}
				}
				&.primary {
					color: #fff !important;
					background-color: #00a3ff !important;
				}
			}
		}
	`
	async showToast(opts: ToastOptions) {
		const toast = await this.toastControler
			.create({
				...opts,
				position: 'bottom',
				cssClass: 'generic-toast'
			})
			.then(element => {
				element.shadowRoot!.adoptedStyleSheets[0].insertRule(this.cssStyleSheetReplace)
				return element
			})
		return await toast.present()
	}
}
